import React from 'react';
import { LogoWithText } from '../Logos';

import FiveHundredError from './FiveHundredError';
import useStyles from './useStyles';

const FiveHundredErrorPage = () => {
  const { errorPage, errorLogo } = useStyles();
  return (
    <div className={errorPage}>
      <a href="/" className={errorLogo}>
        <LogoWithText />
      </a>
      <FiveHundredError />
    </div>
  );
};

export default FiveHundredErrorPage;
